import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

// prettier-ignore
const UserInfo = () => import('@/entities/user-info/user-info.vue');
// prettier-ignore
const UserInfoUpdate = () => import('@/entities/user-info/user-info-update.vue');
// prettier-ignore
const UserInfoDetails = () => import('@/entities/user-info/user-info-details.vue');
// prettier-ignore
const CompteClient = () => import('@/entities/compte-client/compte-client.vue');
// prettier-ignore
const CompteClientUpdate = () => import('@/entities/compte-client/compte-client-update.vue');
// prettier-ignore
const CompteClientDetails = () => import('@/entities/compte-client/compte-client-details.vue');
// prettier-ignore
const Evenement = () => import('@/entities/evenement/evenement.vue');
// prettier-ignore
const EvenementUpdate = () => import('@/entities/evenement/evenement-update.vue');
// prettier-ignore
const EvenementDetails = () => import('@/entities/evenement/evenement-details.vue');
// prettier-ignore
const Conference = () => import('@/entities/conference/conference.vue');
// prettier-ignore
const ConferenceUpdate = () => import('@/entities/conference/conference-update.vue');
// prettier-ignore
const ConferenceDetails = () => import('@/entities/conference/conference-details.vue');
// prettier-ignore
const Inscription = () => import('@/entities/inscription/inscription.vue');
// prettier-ignore
const InscriptionUpdate = () => import('@/entities/inscription/inscription-update.vue');
// prettier-ignore
const InscriptionDetails = () => import('@/entities/inscription/inscription-details.vue');
// prettier-ignore
const Participation = () => import('@/entities/participation/participation.vue');
// prettier-ignore
const ParticipationUpdate = () => import('@/entities/participation/participation-update.vue');
// prettier-ignore
const ParticipationDetails = () => import('@/entities/participation/participation-details.vue');
// prettier-ignore
const Kiosque = () => import('@/entities/kiosque/kiosque.vue');
// prettier-ignore
const KiosqueUpdate = () => import('@/entities/kiosque/kiosque-update.vue');
// prettier-ignore
const KiosqueDetails = () => import('@/entities/kiosque/kiosque-details.vue');
// prettier-ignore
const KiosqueVisite = () => import('@/entities/kiosque-visite/kiosque-visite.vue');
// prettier-ignore
const KiosqueVisiteUpdate = () => import('@/entities/kiosque-visite/kiosque-visite-update.vue');
// prettier-ignore
const KiosqueVisiteDetails = () => import('@/entities/kiosque-visite/kiosque-visite-details.vue');
// prettier-ignore
const Document = () => import('@/entities/document/document.vue');
// prettier-ignore
const DocumentUpdate = () => import('@/entities/document/document-update.vue');
// prettier-ignore
const DocumentDetails = () => import('@/entities/document/document-details.vue');
// prettier-ignore
const DocumentTelechargement = () => import('@/entities/document-telechargement/document-telechargement.vue');
// prettier-ignore
const DocumentTelechargementUpdate = () => import('@/entities/document-telechargement/document-telechargement-update.vue');
// prettier-ignore
const DocumentTelechargementDetails = () => import('@/entities/document-telechargement/document-telechargement-details.vue');
// prettier-ignore
const AffRespCompteClient = () => import('@/entities/aff-resp-compte-client/aff-resp-compte-client.vue');
// prettier-ignore
const AffRespCompteClientUpdate = () => import('@/entities/aff-resp-compte-client/aff-resp-compte-client-update.vue');
// prettier-ignore
const AffRespCompteClientDetails = () => import('@/entities/aff-resp-compte-client/aff-resp-compte-client-details.vue');
// prettier-ignore
const AffRespKiosque = () => import('@/entities/aff-resp-kiosque/aff-resp-kiosque.vue');
// prettier-ignore
const AffRespKiosqueUpdate = () => import('@/entities/aff-resp-kiosque/aff-resp-kiosque-update.vue');
// prettier-ignore
const AffRespKiosqueDetails = () => import('@/entities/aff-resp-kiosque/aff-resp-kiosque-details.vue');
// prettier-ignore
const Usager = () => import('@/entities/usager/usager.vue');
// prettier-ignore
const UsagerUpdate = () => import('@/entities/usager/usager-update.vue');
// prettier-ignore
const UsagerDetails = () => import('@/entities/usager/usager-details.vue');
// prettier-ignore
const Adresse = () => import('@/entities/adresse/adresse.vue');
// prettier-ignore
const AdresseUpdate = () => import('@/entities/adresse/adresse-update.vue');
// prettier-ignore
const AdresseDetails = () => import('@/entities/adresse/adresse-details.vue');
// prettier-ignore
const Sondage = () => import('@/entities/sondage/sondage.vue');
// prettier-ignore
const SondageUpdate = () => import('@/entities/sondage/sondage-update.vue');
// prettier-ignore
const SondageDetails = () => import('@/entities/sondage/sondage-details.vue');
// prettier-ignore
const SondageQuestion = () => import('@/entities/sondage-question/sondage-question.vue');
// prettier-ignore
const SondageQuestionUpdate = () => import('@/entities/sondage-question/sondage-question-update.vue');
// prettier-ignore
const SondageQuestionDetails = () => import('@/entities/sondage-question/sondage-question-details.vue');
// prettier-ignore
const SondageChoix = () => import('@/entities/sondage-choix/sondage-choix.vue');
// prettier-ignore
const SondageChoixUpdate = () => import('@/entities/sondage-choix/sondage-choix-update.vue');
// prettier-ignore
const SondageChoixDetails = () => import('@/entities/sondage-choix/sondage-choix-details.vue');
// prettier-ignore
const SondageReponse = () => import('@/entities/sondage-reponse/sondage-reponse.vue');
// prettier-ignore
const SondageReponseUpdate = () => import('@/entities/sondage-reponse/sondage-reponse-update.vue');
// prettier-ignore
const SondageReponseDetails = () => import('@/entities/sondage-reponse/sondage-reponse-details.vue');
// prettier-ignore
const Media = () => import('@/entities/media/media.vue');
// prettier-ignore
const MediaUpdate = () => import('@/entities/media/media-update.vue');
// prettier-ignore
const MediaDetails = () => import('@/entities/media/media-details.vue');
// prettier-ignore
const AffEvenementKiosque = () => import('@/entities/aff-evenement-kiosque/aff-evenement-kiosque.vue');
// prettier-ignore
const AffEvenementKiosqueUpdate = () => import('@/entities/aff-evenement-kiosque/aff-evenement-kiosque-update.vue');
// prettier-ignore
const AffEvenementKiosqueDetails = () => import('@/entities/aff-evenement-kiosque/aff-evenement-kiosque-details.vue');
// prettier-ignore
const Atelier = () => import('@/entities/atelier/atelier.vue');
// prettier-ignore
const AtelierUpdate = () => import('@/entities/atelier/atelier-update.vue');
// prettier-ignore
const AtelierDetails = () => import('@/entities/atelier/atelier-details.vue');
// prettier-ignore
const AtelierPlace = () => import('@/entities/atelier-place/atelier-place.vue');
// prettier-ignore
const AtelierPlaceUpdate = () => import('@/entities/atelier-place/atelier-place-update.vue');
// prettier-ignore
const AtelierPlaceDetails = () => import('@/entities/atelier-place/atelier-place-details.vue');
// prettier-ignore
const SessionPresence = () => import('@/entities/session-presence/session-presence.vue');
// prettier-ignore
const SessionPresenceUpdate = () => import('@/entities/session-presence/session-presence-update.vue');
// prettier-ignore
const SessionPresenceDetails = () => import('@/entities/session-presence/session-presence-details.vue');
// prettier-ignore
const Presence = () => import('@/entities/presence/presence.vue');
// prettier-ignore
const PresenceUpdate = () => import('@/entities/presence/presence-update.vue');
// prettier-ignore
const PresenceDetails = () => import('@/entities/presence/presence-details.vue');
// prettier-ignore
const Parametre = () => import('@/entities/parametre/parametre.vue');
// prettier-ignore
const ParametreUpdate = () => import('@/entities/parametre/parametre-update.vue');
// prettier-ignore
const ParametreDetails = () => import('@/entities/parametre/parametre-details.vue');
// prettier-ignore
const PriseParole = () => import('@/entities/prise-parole/prise-parole.vue');
// prettier-ignore
const PriseParoleUpdate = () => import('@/entities/prise-parole/prise-parole-update.vue');
// prettier-ignore
const PriseParoleDetails = () => import('@/entities/prise-parole/prise-parole-details.vue');
// prettier-ignore
const AffConferencierConference = () => import('@/entities/aff-conferencier-conference/aff-conferencier-conference.vue');
// prettier-ignore
const AffConferencierConferenceUpdate = () => import('@/entities/aff-conferencier-conference/aff-conferencier-conference-update.vue');
// prettier-ignore
const AffConferencierConferenceDetails = () => import('@/entities/aff-conferencier-conference/aff-conferencier-conference-details.vue');
// prettier-ignore
const CnxConfiguration = () => import('@/entities/cnx-configuration/cnx-configuration.vue');
// prettier-ignore
const CnxConfigurationUpdate = () => import('@/entities/cnx-configuration/cnx-configuration-update.vue');
// prettier-ignore
const CnxConfigurationDetails = () => import('@/entities/cnx-configuration/cnx-configuration-details.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  {
    path: '/user-info',
    name: 'UserInfo',
    component: UserInfo,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/user-info/new',
    name: 'UserInfoCreate',
    component: UserInfoUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/user-info/:userInfoId/edit',
    name: 'UserInfoEdit',
    component: UserInfoUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/user-info/:userInfoId/view',
    name: 'UserInfoView',
    component: UserInfoDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Inscription,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/new',
    name: 'InscriptionCreate',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/edit',
    name: 'InscriptionEdit',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/view',
    name: 'InscriptionView',
    component: InscriptionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite',
    name: 'KiosqueVisite',
    component: KiosqueVisite,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/new',
    name: 'KiosqueVisiteCreate',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/edit',
    name: 'KiosqueVisiteEdit',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/view',
    name: 'KiosqueVisiteView',
    component: KiosqueVisiteDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client',
    name: 'AffRespCompteClient',
    component: AffRespCompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/new',
    name: 'AffRespCompteClientCreate',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/edit',
    name: 'AffRespCompteClientEdit',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/view',
    name: 'AffRespCompteClientView',
    component: AffRespCompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque',
    name: 'AffRespKiosque',
    component: AffRespKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/new',
    name: 'AffRespKiosqueCreate',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/edit',
    name: 'AffRespKiosqueEdit',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/view',
    name: 'AffRespKiosqueView',
    component: AffRespKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse',
    name: 'Adresse',
    component: Adresse,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/new',
    name: 'AdresseCreate',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/edit',
    name: 'AdresseEdit',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/view',
    name: 'AdresseView',
    component: AdresseDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client',
    name: 'AffRespCompteClient',
    component: AffRespCompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/new',
    name: 'AffRespCompteClientCreate',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/edit',
    name: 'AffRespCompteClientEdit',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/view',
    name: 'AffRespCompteClientView',
    component: AffRespCompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Inscription,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/new',
    name: 'InscriptionCreate',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/edit',
    name: 'InscriptionEdit',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/view',
    name: 'InscriptionView',
    component: InscriptionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque',
    name: 'AffRespKiosque',
    component: AffRespKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/new',
    name: 'AffRespKiosqueCreate',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/edit',
    name: 'AffRespKiosqueEdit',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/view',
    name: 'AffRespKiosqueView',
    component: AffRespKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite',
    name: 'KiosqueVisite',
    component: KiosqueVisite,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/new',
    name: 'KiosqueVisiteCreate',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/edit',
    name: 'KiosqueVisiteEdit',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/view',
    name: 'KiosqueVisiteView',
    component: KiosqueVisiteDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse',
    name: 'Adresse',
    component: Adresse,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/new',
    name: 'AdresseCreate',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/edit',
    name: 'AdresseEdit',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/view',
    name: 'AdresseView',
    component: AdresseDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client',
    name: 'AffRespCompteClient',
    component: AffRespCompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/new',
    name: 'AffRespCompteClientCreate',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/edit',
    name: 'AffRespCompteClientEdit',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/view',
    name: 'AffRespCompteClientView',
    component: AffRespCompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Inscription,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/new',
    name: 'InscriptionCreate',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/edit',
    name: 'InscriptionEdit',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/view',
    name: 'InscriptionView',
    component: InscriptionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque',
    name: 'AffRespKiosque',
    component: AffRespKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/new',
    name: 'AffRespKiosqueCreate',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/edit',
    name: 'AffRespKiosqueEdit',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/view',
    name: 'AffRespKiosqueView',
    component: AffRespKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite',
    name: 'KiosqueVisite',
    component: KiosqueVisite,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/new',
    name: 'KiosqueVisiteCreate',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/edit',
    name: 'KiosqueVisiteEdit',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/view',
    name: 'KiosqueVisiteView',
    component: KiosqueVisiteDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse',
    name: 'Adresse',
    component: Adresse,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/new',
    name: 'AdresseCreate',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/edit',
    name: 'AdresseEdit',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/view',
    name: 'AdresseView',
    component: AdresseDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client',
    name: 'AffRespCompteClient',
    component: AffRespCompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/new',
    name: 'AffRespCompteClientCreate',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/edit',
    name: 'AffRespCompteClientEdit',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/view',
    name: 'AffRespCompteClientView',
    component: AffRespCompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Inscription,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/new',
    name: 'InscriptionCreate',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/edit',
    name: 'InscriptionEdit',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/view',
    name: 'InscriptionView',
    component: InscriptionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque',
    name: 'AffRespKiosque',
    component: AffRespKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/new',
    name: 'AffRespKiosqueCreate',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/edit',
    name: 'AffRespKiosqueEdit',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/view',
    name: 'AffRespKiosqueView',
    component: AffRespKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite',
    name: 'KiosqueVisite',
    component: KiosqueVisite,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/new',
    name: 'KiosqueVisiteCreate',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/edit',
    name: 'KiosqueVisiteEdit',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/view',
    name: 'KiosqueVisiteView',
    component: KiosqueVisiteDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse',
    name: 'Adresse',
    component: Adresse,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/new',
    name: 'AdresseCreate',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/edit',
    name: 'AdresseEdit',
    component: AdresseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/adresse/:adresseId/view',
    name: 'AdresseView',
    component: AdresseDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client',
    name: 'AffRespCompteClient',
    component: AffRespCompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/new',
    name: 'AffRespCompteClientCreate',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/edit',
    name: 'AffRespCompteClientEdit',
    component: AffRespCompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-compte-client/:affRespCompteClientId/view',
    name: 'AffRespCompteClientView',
    component: AffRespCompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Inscription,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/new',
    name: 'InscriptionCreate',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/edit',
    name: 'InscriptionEdit',
    component: InscriptionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/inscription/:inscriptionId/view',
    name: 'InscriptionView',
    component: InscriptionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque',
    name: 'AffRespKiosque',
    component: AffRespKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/new',
    name: 'AffRespKiosqueCreate',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/edit',
    name: 'AffRespKiosqueEdit',
    component: AffRespKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-resp-kiosque/:affRespKiosqueId/view',
    name: 'AffRespKiosqueView',
    component: AffRespKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite',
    name: 'KiosqueVisite',
    component: KiosqueVisite,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/new',
    name: 'KiosqueVisiteCreate',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/edit',
    name: 'KiosqueVisiteEdit',
    component: KiosqueVisiteUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque-visite/:kiosqueVisiteId/view',
    name: 'KiosqueVisiteView',
    component: KiosqueVisiteDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document',
    name: 'Document',
    component: Document,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/new',
    name: 'DocumentCreate',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/edit',
    name: 'DocumentEdit',
    component: DocumentUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document/:documentId/view',
    name: 'DocumentView',
    component: DocumentDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement',
    name: 'DocumentTelechargement',
    component: DocumentTelechargement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/new',
    name: 'DocumentTelechargementCreate',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/edit',
    name: 'DocumentTelechargementEdit',
    component: DocumentTelechargementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/document-telechargement/:documentTelechargementId/view',
    name: 'DocumentTelechargementView',
    component: DocumentTelechargementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage',
    name: 'Sondage',
    component: Sondage,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/new',
    name: 'SondageCreate',
    component: SondageUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/:sondageId/edit',
    name: 'SondageEdit',
    component: SondageUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/:sondageId/view',
    name: 'SondageView',
    component: SondageDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-question',
    name: 'SondageQuestion',
    component: SondageQuestion,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-question/new',
    name: 'SondageQuestionCreate',
    component: SondageQuestionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-question/:sondageQuestionId/edit',
    name: 'SondageQuestionEdit',
    component: SondageQuestionUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-question/:sondageQuestionId/view',
    name: 'SondageQuestionView',
    component: SondageQuestionDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix',
    name: 'SondageChoix',
    component: SondageChoix,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/new',
    name: 'SondageChoixCreate',
    component: SondageChoixUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/:sondageChoixId/edit',
    name: 'SondageChoixEdit',
    component: SondageChoixUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/:sondageChoixId/view',
    name: 'SondageChoixView',
    component: SondageChoixDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-reponse',
    name: 'SondageReponse',
    component: SondageReponse,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-reponse/new',
    name: 'SondageReponseCreate',
    component: SondageReponseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-reponse/:sondageReponseId/edit',
    name: 'SondageReponseEdit',
    component: SondageReponseUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-reponse/:sondageReponseId/view',
    name: 'SondageReponseView',
    component: SondageReponseDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/sondage-choix',
    name: 'SondageChoix',
    component: SondageChoix,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/new',
    name: 'SondageChoixCreate',
    component: SondageChoixUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/:sondageChoixId/edit',
    name: 'SondageChoixEdit',
    component: SondageChoixUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage-choix/:sondageChoixId/view',
    name: 'SondageChoixView',
    component: SondageChoixDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/media',
    name: 'Media',
    component: Media,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/new',
    name: 'MediaCreate',
    component: MediaUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/:mediaId/edit',
    name: 'MediaEdit',
    component: MediaUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/:mediaId/view',
    name: 'MediaView',
    component: MediaDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/media',
    name: 'Media',
    component: Media,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/new',
    name: 'MediaCreate',
    component: MediaUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/:mediaId/edit',
    name: 'MediaEdit',
    component: MediaUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/media/:mediaId/view',
    name: 'MediaView',
    component: MediaDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/compte-client',
    name: 'CompteClient',
    component: CompteClient,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/new',
    name: 'CompteClientCreate',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/edit',
    name: 'CompteClientEdit',
    component: CompteClientUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/compte-client/:compteClientId/view',
    name: 'CompteClientView',
    component: CompteClientDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque',
    name: 'AffEvenementKiosque',
    component: AffEvenementKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/new',
    name: 'AffEvenementKiosqueCreate',
    component: AffEvenementKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/:affEvenementKiosqueId/edit',
    name: 'AffEvenementKiosqueEdit',
    component: AffEvenementKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/:affEvenementKiosqueId/view',
    name: 'AffEvenementKiosqueView',
    component: AffEvenementKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/aff-evenement-kiosque',
    name: 'AffEvenementKiosque',
    component: AffEvenementKiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/new',
    name: 'AffEvenementKiosqueCreate',
    component: AffEvenementKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/:affEvenementKiosqueId/edit',
    name: 'AffEvenementKiosqueEdit',
    component: AffEvenementKiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-evenement-kiosque/:affEvenementKiosqueId/view',
    name: 'AffEvenementKiosqueView',
    component: AffEvenementKiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/sondage',
    name: 'Sondage',
    component: Sondage,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/new',
    name: 'SondageCreate',
    component: SondageUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/:sondageId/edit',
    name: 'SondageEdit',
    component: SondageUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/sondage/:sondageId/view',
    name: 'SondageView',
    component: SondageDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier',
    name: 'Atelier',
    component: Atelier,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier/new',
    name: 'AtelierCreate',
    component: AtelierUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier/:atelierId/edit',
    name: 'AtelierEdit',
    component: AtelierUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier/:atelierId/view',
    name: 'AtelierView',
    component: AtelierDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier-place',
    name: 'AtelierPlace',
    component: AtelierPlace,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier-place/new',
    name: 'AtelierPlaceCreate',
    component: AtelierPlaceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier-place/:atelierPlaceId/edit',
    name: 'AtelierPlaceEdit',
    component: AtelierPlaceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/atelier-place/:atelierPlaceId/view',
    name: 'AtelierPlaceView',
    component: AtelierPlaceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/usager',
    name: 'Usager',
    component: Usager,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/new',
    name: 'UsagerCreate',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/edit',
    name: 'UsagerEdit',
    component: UsagerUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/usager/:usagerId/view',
    name: 'UsagerView',
    component: UsagerDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kiosque',
    name: 'Kiosque',
    component: Kiosque,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/new',
    name: 'KiosqueCreate',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/edit',
    name: 'KiosqueEdit',
    component: KiosqueUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kiosque/:kiosqueId/view',
    name: 'KiosqueView',
    component: KiosqueDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/evenement',
    name: 'Evenement',
    component: Evenement,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/new',
    name: 'EvenementCreate',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/edit',
    name: 'EvenementEdit',
    component: EvenementUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/evenement/:evenementId/view',
    name: 'EvenementView',
    component: EvenementDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/conference',
    name: 'Conference',
    component: Conference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/new',
    name: 'ConferenceCreate',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/edit',
    name: 'ConferenceEdit',
    component: ConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/conference/:conferenceId/view',
    name: 'ConferenceView',
    component: ConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/participation',
    name: 'Participation',
    component: Participation,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/new',
    name: 'ParticipationCreate',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/edit',
    name: 'ParticipationEdit',
    component: ParticipationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/participation/:participationId/view',
    name: 'ParticipationView',
    component: ParticipationDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/session-presence',
    name: 'SessionPresence',
    component: SessionPresence,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/new',
    name: 'SessionPresenceCreate',
    component: SessionPresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/:sessionPresenceId/edit',
    name: 'SessionPresenceEdit',
    component: SessionPresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/:sessionPresenceId/view',
    name: 'SessionPresenceView',
    component: SessionPresenceDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/presence',
    name: 'Presence',
    component: Presence,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/presence/new',
    name: 'PresenceCreate',
    component: PresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/presence/:presenceId/edit',
    name: 'PresenceEdit',
    component: PresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/presence/:presenceId/view',
    name: 'PresenceView',
    component: PresenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/session-presence',
    name: 'SessionPresence',
    component: SessionPresence,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/new',
    name: 'SessionPresenceCreate',
    component: SessionPresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/:sessionPresenceId/edit',
    name: 'SessionPresenceEdit',
    component: SessionPresenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/session-presence/:sessionPresenceId/view',
    name: 'SessionPresenceView',
    component: SessionPresenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/parametre',
    name: 'Parametre',
    component: Parametre,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/parametre/new',
    name: 'ParametreCreate',
    component: ParametreUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/parametre/:parametreId/edit',
    name: 'ParametreEdit',
    component: ParametreUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/parametre/:parametreId/view',
    name: 'ParametreView',
    component: ParametreDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/prise-parole',
    name: 'PriseParole',
    component: PriseParole,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/new',
    name: 'PriseParoleCreate',
    component: PriseParoleUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/:priseParoleId/edit',
    name: 'PriseParoleEdit',
    component: PriseParoleUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/:priseParoleId/view',
    name: 'PriseParoleView',
    component: PriseParoleDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/prise-parole',
    name: 'PriseParole',
    component: PriseParole,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/new',
    name: 'PriseParoleCreate',
    component: PriseParoleUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/:priseParoleId/edit',
    name: 'PriseParoleEdit',
    component: PriseParoleUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/prise-parole/:priseParoleId/view',
    name: 'PriseParoleView',
    component: PriseParoleDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/aff-conferencier-conference',
    name: 'AffConferencierConference',
    component: AffConferencierConference,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-conferencier-conference/new',
    name: 'AffConferencierConferenceCreate',
    component: AffConferencierConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-conferencier-conference/:affConferencierConferenceId/edit',
    name: 'AffConferencierConferenceEdit',
    component: AffConferencierConferenceUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/aff-conferencier-conference/:affConferencierConferenceId/view',
    name: 'AffConferencierConferenceView',
    component: AffConferencierConferenceDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/cnx-configuration',
    name: 'CnxConfiguration',
    component: CnxConfiguration,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/new',
    name: 'CnxConfigurationCreate',
    component: CnxConfigurationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/:cnxConfigurationId/edit',
    name: 'CnxConfigurationEdit',
    component: CnxConfigurationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/:cnxConfigurationId/view',
    name: 'CnxConfigurationView',
    component: CnxConfigurationDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/cnx-configuration',
    name: 'CnxConfiguration',
    component: CnxConfiguration,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/new',
    name: 'CnxConfigurationCreate',
    component: CnxConfigurationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/:cnxConfigurationId/edit',
    name: 'CnxConfigurationEdit',
    component: CnxConfigurationUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/cnx-configuration/:cnxConfigurationId/view',
    name: 'CnxConfigurationView',
    component: CnxConfigurationDetails,
    meta: { authorities: [Authority.USER] },
  },
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
